<template>
	<div class="container">
		<canvas ref="qrcode"></canvas>
	</div>
</template>

<script>
	import QRCode from 'qrcode'
	import {
		baseUrl
	} from '@/config.js'

	export default {
		mounted() {

			document.title = '生成二维码';
			this.generateQRCode()

			// this.$router.push({
			// 	name: 'AuthToken',
			// 	query: {
			// 		"orderId": "HS20250221111033312"
			// 	}
			// })
		},
		methods: {


			async generateQRCode() {
				console.log("baseUrl - - -", baseUrl);
				console.log("window.location.origin - - -", window.location.origin);
				const url = `${window.location.origin}/auth_tokenorderId=` + "HS20250221111033312"
				// const url = `${baseUrl}/#/auth_token?orderId=` + "HS20250221111033312"
				console.log("url - - -", url);
				QRCode.toCanvas(this.$refs.qrcode, url, {
					width: 300
				}, (error) => {
					if (error) console.error(error)
				})
			}
		}
	}
</script>